import React, { useState, useEffect } from 'react';

const PAGES = 5;

const PageNavigation = props => {
    const { postType='', postLabel='', totalCount, showCount = 5, onChange = () => {} } = props;
    const [currentPage, setCurrentPage] = useState(1);
    
    const totalPages = Math.ceil(totalCount / showCount);

    const handleFirstPage = () => setCurrentPage(1);
    const handleLastPage = () => setCurrentPage(totalPages);
    const handlePrevPage = () => setCurrentPage(prev => Math.max(prev - 1, 1));
    const handleNextPage = () => setCurrentPage(prev => Math.min(prev + 1, totalPages));

    const getPageNumbers = () => {
        const pages = [];
        const startPage = totalPages <= PAGES ? 1 : Math.max(currentPage - 2, 1);
        const endPage = Math.min(startPage + PAGES - 1, totalPages);
        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }
        return pages;
    };

    useEffect(() => {
        setCurrentPage(1);
    }, [postType, postLabel]);

    useEffect(() => {
        onChange(currentPage);
    }, [currentPage]);

    if (totalPages === 1) return '';

    return (
        <div className="section-content-tool">
            <div className="section-pagination">
                {totalPages > 5 && <>
                    <button type="button" onClick={handleFirstPage} disabled={currentPage === 1}>
                        <i className="fas fa-angle-double-left"></i>
                    </button>
                    <button type="button" onClick={handlePrevPage} disabled={currentPage === 1}>
                        <i className="fas fa-angle-left"></i>
                    </button>
                </>}   
                <div className="section-pagination-bullet">
                    {getPageNumbers().map(page => (
                        <button
                            key={page}
                            className={page === currentPage ? 'active' : ''}
                            onClick={() => setCurrentPage(page)}
                        >{page}
                        </button>
                    ))}
                </div>
                {totalPages > 5 && <>
                    <button type="button" onClick={handleNextPage} disabled={currentPage === totalPages}>
                        <i className="fas fa-angle-right"></i>
                    </button>
                    <button type="button" onClick={handleLastPage} disabled={currentPage === totalPages}>
                        <i className="fas fa-angle-double-right"></i>
                    </button>
                </>}
            </div>            
        </div>
    );
};

export default PageNavigation;

